export const categories = [
  { id: 1, name: '热门推荐', slug: 'hot', icon: 'ri-fire-line' },
  { id: 2, name: '恋爱言情', slug: 'romance', icon: 'ri-heart-line' },
  { id: 3, name: '奇幻冒险', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 4, name: '动作热血', slug: 'action', icon: 'ri-flashlight-line' },
  { id: 5, name: '悬疑推理', slug: 'mystery', icon: 'ri-search-eye-line' },
  { id: 6, name: '搞笑日常', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 7, name: '耽美BL', slug: 'bl', icon: 'ri-user-heart-line' },
  { id: 8, name: '恐怖惊悚', slug: 'horror', icon: 'ri-ghost-line' },
];

export const comics = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: 'action',
    coverSeq: 'comic-cover-solo-leveling',
    rating: 9.8,
    status: '连载中',
    updateChapter: '第 200 话',
    updateDate: '2026-08-05',
    description: '十多年前，世界上突然出现了连接异次元与现世的"传送门"，而其中觉醒的人类被称为"猎人"。故事围绕最弱E级猎人成振宇展开，他在一次地下城探险中濒临死亡，却意外获得了神秘的"系统"能力，从此开启了一段从最弱到最强的逆袭之路。本作以精彩的战斗场面和独特的升级系统著称，是韩国漫画的经典之作。',
    chapters: 200,
    views: 15280000,
    tags: ['热血', '升级', '系统', '逆袭', '战斗'],
  },
  {
    id: 2,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'romance',
    coverSeq: 'comic-cover-true-beauty',
    rating: 9.5,
    status: '已完结',
    updateChapter: '第 224 话（完结）',
    updateDate: '2026-07-20',
    description: '任朱静因为外貌在学校受到欺凌，通过化妆学习成为了一名"女神"。她隐藏着自己的素颜秘密，在两个性格迥异的男生之间产生了微妙的感情。一个是高冷校草李修豪，一个是热情阳光的韩书俊。本作以细腻的情感描写和真实的校园生活引发读者共鸣，探讨了外貌与自信的主题。',
    chapters: 224,
    views: 23500000,
    tags: ['恋爱', '校园', '化妆', '三角恋', '成长'],
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: 'fantasy',
    coverSeq: 'comic-cover-omniscient-reader',
    rating: 9.7,
    status: '连载中',
    updateChapter: '第 185 话',
    updateDate: '2026-08-04',
    description: '金独子是唯一一个读完了连载长达3149话的网络小说《在灭亡的世界中生存的三种方法》的读者。当小说中的末日场景在现实中上演时，他凭借对剧情的了解，在这个毁灭的世界中一步步前行。本作以宏大的世界观设定和巧妙的剧情反转获得了极高评价，是近年来最具创意的韩国漫画之一。',
    chapters: 185,
    views: 18900000,
    tags: ['末世', '系统', '智斗', '生存', '剧情'],
  },
  {
    id: 4,
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    category: 'fantasy',
    coverSeq: 'comic-cover-who-made-me-princess',
    rating: 9.6,
    status: '已完结',
    updateChapter: '第 125 话（完结）',
    updateDate: '2026-06-15',
    description: '醒来发现自己穿越成了小说中的公主——一个注定要被亲生父亲处死的悲剧角色。为了改变命运，她决定用可爱和撒娇来攻略那个冷血无情的皇帝父亲。本作以温馨可爱的画风和感人至深的父女情打动了无数读者，是穿越题材韩国漫画中的巅峰之作。',
    chapters: 125,
    views: 21300000,
    tags: ['穿越', '宫廷', '父女', '治愈', '逆袭'],
  },
  {
    id: 5,
    title: '剑尊归来',
    author: 'Lico / Biga',
    category: 'action',
    coverSeq: 'comic-cover-swordmaster-return',
    rating: 9.4,
    status: '连载中',
    updateChapter: '第 156 话',
    updateDate: '2026-08-03',
    description: '上一世被誉为天下第一剑的强者，在临终前发誓要纠正自己残暴的一生。当他再次睁开眼睛时发现自己回到了少年时代。带着前世的记忆和剑术，他决定走上一条与前世截然不同的道路。本作以华丽的剑术对决和深刻的人物成长而备受好评。',
    chapters: 156,
    views: 14500000,
    tags: ['武侠', '重生', '剑术', '成长', '热血'],
  },
  {
    id: 6,
    title: '秘密课程',
    author: 'Han Kkeut',
    category: 'romance',
    coverSeq: 'comic-cover-secret-class',
    rating: 9.2,
    status: '连载中',
    updateChapter: '第 98 话',
    updateDate: '2026-08-02',
    description: '大学生金敏俊在一次偶然的机会下成为了富家女的私人家教。在这段特殊的师生关系中，两人的感情逐渐升温，却面临着来自家庭和社会的重重阻碍。本作以细腻的情感刻画和大胆的剧情发展吸引了大量读者。',
    chapters: 98,
    views: 8900000,
    tags: ['恋爱', '师生', '都市', '禁断', '剧情'],
  },
  {
    id: 7,
    title: '诡秘之主',
    author: 'Cuttlefish / REDICE STUDIO',
    category: 'mystery',
    coverSeq: 'comic-cover-lord-of-mysteries',
    rating: 9.6,
    status: '连载中',
    updateChapter: '第 142 话',
    updateDate: '2026-08-05',
    description: '周明瑞穿越到了一个蒸汽与机械的奇幻世界，成为了一个普通的安保公司职员。在这个充满诡异和神秘的世界中，他必须通过"扮演法"不断提升自己的序列，在诡秘与疯狂的边缘寻求生存之道。本作以独特的克苏鲁风格世界观和缜密的逻辑推理获得了极高的口碑。',
    chapters: 142,
    views: 16700000,
    tags: ['克苏鲁', '蒸汽朋克', '悬疑', '升级', '智斗'],
  },
  {
    id: 8,
    title: '入学档案',
    author: 'Chongtak / NANA',
    category: 'mystery',
    coverSeq: 'comic-cover-admission-archive',
    rating: 9.3,
    status: '连载中',
    updateChapter: '第 88 话',
    updateDate: '2026-08-01',
    description: '一所神秘的国际学校隐藏着不为人知的秘密。新入学的转校生林智雅逐渐发现，这所学校的学生们都在参与一场残酷的生存游戏。为了活下去，她必须在规则中寻找漏洞，揭开学校的真相。本作以紧张刺激的节奏和出人意料的剧情转折闻名。',
    chapters: 88,
    views: 7200000,
    tags: ['校园', '悬疑', '生存游戏', '智斗', '反转'],
  },
  {
    id: 9,
    title: '极速快递',
    author: 'MIYA / SINO',
    category: 'comedy',
    coverSeq: 'comic-cover-express-delivery',
    rating: 9.1,
    status: '连载中',
    updateChapter: '第 112 话',
    updateDate: '2026-08-04',
    description: '失业青年金东秀阴差阳错加入了一家神秘的快递公司，却发现这家公司配送的可不是普通包裹！从异世界的怪物到未来科技产品，每一次配送都是一场疯狂的冒险。本作以轻松搞笑的风格和天马行空的想象力赢得了读者的喜爱。',
    chapters: 112,
    views: 6500000,
    tags: ['搞笑', '冒险', '日常', '奇幻', '职场'],
  },
  {
    id: 10,
    title: '甜蜜的陷阱',
    author: 'DALJAK / SUGAR',
    category: 'romance',
    coverSeq: 'comic-cover-sweet-trap',
    rating: 9.4,
    status: '已完结',
    updateChapter: '第 168 话（完结）',
    updateDate: '2026-07-10',
    description: '职场新人韩素希意外发现公司最帅的部门经理竟然是自己的青梅竹马！更令人震惊的是，这位冷酷的经理在私下里对她展现出了截然不同的温柔一面。本作以甜美的爱情故事和真实的职场描写赢得了大量女性读者的心。',
    chapters: 168,
    views: 12300000,
    tags: ['恋爱', '职场', '青梅竹马', '甜宠', '都市'],
  },
  {
    id: 11,
    title: '恶魔的契约',
    author: 'ZERO / DarkHorse',
    category: 'horror',
    coverSeq: 'comic-cover-devils-contract',
    rating: 9.0,
    status: '连载中',
    updateChapter: '第 76 话',
    updateDate: '2026-08-05',
    description: '一群大学生在废弃的精神病院进行探险直播，却意外唤醒了沉睡百年的恶魔。他们被迫与恶魔签订契约，每完成一个恐怖任务才能获得一天的生存时间。本作以令人窒息的恐怖氛围和出人意料的反转著称。',
    chapters: 76,
    views: 5800000,
    tags: ['恐怖', '灵异', '生存', '契约', '惊悚'],
  },
  {
    id: 12,
    title: '闪耀的继承者',
    author: 'STAR / MOONLIGHT',
    category: 'bl',
    coverSeq: 'comic-cover-shining-heir',
    rating: 9.5,
    status: '连载中',
    updateChapter: '第 134 话',
    updateDate: '2026-08-03',
    description: '财阀私生子韩裕贤回到家族后，与家族首席律师姜泰赫之间展开了一段禁忌的感情。在权力与感情的漩涡中，两人必须做出选择。本作以精致的画风和深刻的情感描写在BL漫画中独树一帜。',
    chapters: 134,
    views: 9800000,
    tags: ['BL', '财阀', '律师', '禁忌', '都市'],
  },
];

export const comicImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%2C%20dark%20haired%20male%20protagonist%20with%20glowing%20blue%20eyes%2C%20holding%20dagger%2C%20dark%20fantasy%20background%20with%20purple%20energy%20effects%2C%20professional%20digital%20illustration%2C%20clean%20manga%20style&width=600&height=800&seq=comic-cover-solo-leveling-1&orientation=portrait',
  2: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20beautiful%20young%20woman%20with%20long%20brown%20hair%2C%20makeup%20theme%2C%20soft%20pink%20and%20peach%20background%20with%20flowers%2C%20gentle%20lighting%2C%20romantic%20digital%20art%20style&width=600&height=800&seq=comic-cover-true-beauty-2&orientation=portrait',
  3: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20male%20protagonist%20in%20black%20coat%2C%20apocalyptic%20city%20background%20with%20orange%20sky%2C%20system%20interface%20hologram%20elements%2C%20dramatic%20lighting%2C%20professional%20digital%20illustration&width=600&height=800&seq=comic-cover-omniscient-reader-3&orientation=portrait',
  4: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20princess%20with%20blonde%20hair%20in%20elegant%20gown%2C%20royal%20palace%20background%20with%20golden%20light%2C%20sparkling%20magic%20effects%2C%20fairy%20tale%20atmosphere%2C%20beautiful%20digital%20art&width=600&height=800&seq=comic-cover-who-made-me-princess-4&orientation=portrait',
  5: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20swordsman%20with%20white%20hair%20holding%20glowing%20sword%2C%20ancient%20Asian%20temple%20background%2C%20cherry%20blossom%20petals%2C%20dynamic%20pose%2C%20martial%20arts%20digital%20illustration&width=600&height=800&seq=comic-cover-swordmaster-return-5&orientation=portrait',
  6: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20young%20couple%20in%20modern%20classroom%20setting%2C%20university%20campus%20background%20with%20warm%20sunlight%2C%20soft%20romantic%20atmosphere%2C%20gentle%20color%20palette%2C%20clean%20digital%20illustration&width=600&height=800&seq=comic-cover-secret-class-6&orientation=portrait',
  7: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20manhwa%20cover%2C%20man%20in%20Victorian%20era%20coat%20with%20top%20hat%2C%20steampunk%20city%20background%20with%20clock%20tower%2C%20foggy%20atmosphere%2C%20dark%20mysterious%20mood%2C%20Lovecraftian%20digital%20art&width=600&height=800&seq=comic-cover-lord-of-mysteries-7&orientation=portrait',
  8: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%2C%20female%20student%20in%20school%20uniform%2C%20dark%20corridor%20background%20with%20mysterious%20shadows%2C%20suspenseful%20atmosphere%2C%20cool%20blue%20tone%2C%20digital%20illustration&width=600&height=800&seq=comic-cover-admission-archive-8&orientation=portrait',
  9: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20young%20delivery%20man%20with%20helmet%20holding%20mysterious%20package%2C%20colorful%20city%20background%2C%20funny%20expressive%20style%2C%20bright%20vibrant%20colors%2C%20lighthearted%20digital%20art&width=600&height=800&seq=comic-cover-express-delivery-9&orientation=portrait',
  10: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20stylish%20office%20woman%20and%20handsome%20man%20in%20suit%2C%20modern%20office%20background%20with%20city%20view%2C%20warm%20evening%20light%2C%20romantic%20professional%20atmosphere%2C%20digital%20illustration&width=600&height=800&seq=comic-cover-sweet-trap-10&orientation=portrait',
  11: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20cover%2C%20dark%20abandoned%20hospital%20corridor%2C%20shadowy%20figure%20with%20red%20glowing%20eyes%2C%20eerie%20atmosphere%2C%20blood%20red%20accents%2C%20creepy%20digital%20horror%20art&width=600&height=800&seq=comic-cover-devils-contract-11&orientation=portrait',
  12: 'https://readdy.ai/api/search-image?query=Korean%20BL%20romance%20manhwa%20cover%2C%20two%20elegant%20men%20in%20luxury%20suits%2C%20penthouse%20background%20with%20city%20night%20view%2C%20moody%20romantic%20lighting%2C%20sophisticated%20digital%20art%20style&width=600&height=800&seq=comic-cover-shining-heir-12&orientation=portrait',
};

export const reviews = [
  { id: 1, username: '漫画迷小王', rating: 5, content: '虫虫漫画网的更新速度真的快！每次韩国那边刚更新，这里就有了，而且画质超级清晰，下拉观看的体验太棒了！', date: '2026-08-04' },
  { id: 2, username: '静静看书', rating: 5, content: '一直在找能看完整版无删减韩国漫画的平台，终于找到了！虫虫漫画网的资源太全了，推荐给所有喜欢韩国漫画的朋友。', date: '2026-08-03' },
  { id: 3, username: '夜雨声烦', rating: 5, content: '下拉式阅读真的太方便了，不用一页页翻，流畅度也很高。网站设计也很清爽，没有乱七八糟的广告，体验非常好！', date: '2026-08-02' },
  { id: 4, username: '追漫达人', rating: 4, content: '用了半年多了，漫画种类越来越多，翻译质量也很稳定。希望能增加更多分类筛选的功能，让找漫画更方便。', date: '2026-08-01' },
  { id: 5, username: '樱花飘落', rating: 5, content: '从朋友那里知道的这个网站，一试就停不下来了！韩国漫画的画风和剧情都很吸引人，虫虫漫画网的翻译也很到位，强烈推荐！', date: '2026-07-30' },
  { id: 6, username: '书虫阿明', rating: 5, content: '之前在很多平台看漫画，要么删减要么收费，虫虫漫画网真的是一股清流。免费完整版还能保持这么好的更新频率，太难得了！', date: '2026-07-28' },
];

export const faqs = [
  {
    question: '虫虫漫画网是免费的吗？',
    answer: '是的，虫虫漫画网所有漫画资源均免费提供阅读，无需付费订阅，无需购买会员。我们致力于为广大漫画爱好者提供高质量的免费漫画阅读体验。',
  },
  {
    question: '漫画是否有删减？',
    answer: '虫虫漫画网主打无删减完整版漫画阅读。我们提供的所有韩国漫画均保持原版内容完整，不进行任何删减处理，确保读者能够看到最原汁原味的漫画内容。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是专为手机和网页端优化的一种漫画阅读方式。读者只需向下滑动屏幕即可连续阅读，无需翻页点击，观看体验流畅自然，特别适合长条形漫画的阅读。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '我们与漫画源保持同步更新，热门连载漫画通常能在原作更新后24小时内提供中文翻译版本。部分热门作品甚至可以实现当天同步更新。',
  },
  {
    question: '如何找到想看的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类型的漫画，也可以使用搜索功能直接搜索漫画名称。我们还设有热门推荐和最新更新板块，帮助您发现更多精彩漫画。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '虫虫漫画网采用响应式设计，完美支持电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅舒适的下拉式漫画阅读体验。',
  },
];

export const latestUpdates = [
  { comicId: 1, title: '我独自升级', chapter: '第 200 话', time: '2小时前' },
  { comicId: 7, title: '诡秘之主', chapter: '第 142 话', time: '3小时前' },
  { comicId: 3, title: '全知读者视角', chapter: '第 185 话', time: '5小时前' },
  { comicId: 11, title: '恶魔的契约', chapter: '第 76 话', time: '6小时前' },
  { comicId: 5, title: '剑尊归来', chapter: '第 156 话', time: '8小时前' },
  { comicId: 9, title: '极速快递', chapter: '第 112 话', time: '10小时前' },
  { comicId: 6, title: '秘密课程', chapter: '第 98 话', time: '12小时前' },
  { comicId: 12, title: '闪耀的继承者', chapter: '第 134 话', time: '14小时前' },
  { comicId: 2, title: '女神降临', chapter: '第 224 话（完结）', time: '1天前' },
  { comicId: 8, title: '入学档案', chapter: '第 88 话', time: '1天前' },
];